var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oct-form__col",class:[{
    'oct-form__col--dense': _vm.dense
  },`oct-form__col--${_vm.columnWidth}`]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }